import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import ScreenReaderText from '../../utilities/screen-reader-text/index.js';
import '../../utilities/use-viewport/index.js';
import calculateAspectRatio from '../../utilities/calculate-aspect-ratio/index.js';
import styles from './tile-container.module.scss.js';
import { checkIfCustomPadding } from './utils/check-if-custom-padding/index.js';
import { checkBackgroundKind } from './utils/check-background-kind/index.js';
import { validateSurface } from '../../globals.js';

const StaticTileContainer = (_a) => {
    var { height, width = '100%', aspectRatio = '1/1', background = 'lightSecondary', imageFallbackColor = 'lightSecondary', padding = '4X', surface: surfaceProp = 'lightPrimary', showBorder, dropShadow = 'none', id, children, ariaLabel, 'aria-label': ariaLabelNative, borderRadius = 'tile', 'data-testid': testID = 'tile-container' } = _a, rest = __rest(_a, ["height", "width", "aspectRatio", "background", "imageFallbackColor", "padding", "surface", "showBorder", "dropShadow", "id", "children", "ariaLabel", 'aria-label', "borderRadius", 'data-testid']);
    const backgroundKind = checkBackgroundKind(background);
    const imageFallbackColorKind = checkBackgroundKind(imageFallbackColor);
    const isCustomPadding = checkIfCustomPadding(padding);
    const surface = validateSurface(surfaceProp);
    const tileStyles = [
        styles.tileContainer,
        styles[`surface-${surface.toLowerCase()}`],
    ];
    let backgroundToken;
    if (backgroundKind === 'tokenColor') {
        backgroundToken = background;
    }
    if (backgroundKind === 'imageSource' &&
        imageFallbackColorKind === 'tokenColor') {
        backgroundToken = imageFallbackColor;
    }
    /* istanbul ignore if -- @preserve */
    if (backgroundToken) {
        if (backgroundToken !== 'limitedRed') {
            tileStyles.push(styles[`background-${backgroundToken.toLowerCase()}`]);
        }
        else if (backgroundToken === 'limitedRed') {
            // limitedRed is applicable only for heroes
            if (borderRadius === 'hero') {
                tileStyles.push(styles[`background-limitedred`]);
            }
            else {
                tileStyles.push(styles[`background-lightprimary`]);
            }
        }
    }
    /* istanbul ignore if -- @preserve */
    if (!isCustomPadding) {
        tileStyles.push(styles[`spacing-${padding.toLowerCase()}`]);
    }
    /* istanbul ignore if -- @preserve */
    if (showBorder)
        tileStyles.push(styles.showBorder);
    /* istanbul ignore if -- @preserve */
    if (dropShadow !== 'none' && surface.startsWith('light')) {
        /* istanbul ignore if -- @preserve */
        if (dropShadow === 'subtle' && background === 'lightPrimary') {
            tileStyles.push(styles[`shadow-subtle-lightprimary`]);
        }
        /* istanbul ignore if -- @preserve */
        if (dropShadow === 'medium' && background === 'lightPrimary') {
            tileStyles.push(styles[`shadow-medium-lightprimary`]);
        }
        /* istanbul ignore if -- @preserve */
        if (dropShadow === 'medium' &&
            background &&
            !background.startsWith('light')) {
            tileStyles.push(styles[`shawdow-medium-dark`]);
        }
    }
    /* istanbul ignore if -- @preserve */
    if (borderRadius === 'tile' || borderRadius === 'hero') {
        tileStyles.push(styles[borderRadius]);
    }
    const accessibilityText = ariaLabel || ariaLabelNative;
    return (jsxs("div", Object.assign({}, rest, { "data-testid": `${testID}-tile`, tabIndex: undefined, id: id, className: tileStyles.join(' '), style: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ height,
            width }, (backgroundKind === 'imageSource' && {
            backgroundImage: `url(${background})`,
            backgroundColor: imageFallbackColorKind === 'custom'
                ? imageFallbackColor
                : undefined,
        })), (backgroundKind === 'custom' && { background })), (borderRadius !== 'tile' &&
            borderRadius !== 'hero' && {
            borderRadius,
        })), { aspectRatio: height ? undefined : calculateAspectRatio(aspectRatio) }), (isCustomPadding && { padding })), children: [accessibilityText && (jsx(ScreenReaderText, { children: accessibilityText })), jsx("div", { className: styles.innerContainer, "data-testid": `tile-inner-container-${testID}`, id: `tile-inner-container-${id}`, children: children })] })));
};

export { StaticTileContainer as default };
